import { SetStateAction, useEffect, useState } from "react";
import { TitleH1 } from "../../../../Components/CustomUi/titleH1";
import ViewPage from "../../../../Components/ViewPage";
import { ItensPerUserLogged } from "../../../../services/login/permissaoUsuarioLoado";
import { ContainerBody, ContainerVisualizarModulosPermissoes } from "./styled";
import Tabs from "../../../../Components/Tabs";
import Input from "../../../../Components/CustomUi/input";
import { CardsDados } from "./components/cardsClientes";
import { Render } from "../../../../Components/CustomUi/render";
import Carregando from "../../../../Components/CustomUi/loading";
import { GavetaMostrar } from "./components/gavetaMostrar";
import { ClienteItensTypes, getCliente } from "../../../../services/Cliente";
import { EquipeItens, getEquipe } from "../../../../services/Equipe";
import { getPerfil, ItensPerfilTypes } from "../../../../services/perfil";
import { limparPermissoesPerfil } from "./components/meta";
import { CardsDadosConsultoria } from "./components/cardsConsultoria";
import { tiposSistema } from "../../../../services/Afins";
import secureLocalStorage from "react-secure-storage";


const VisualizarModulosPermissoes = () => {
    const [permissions, setPermissions] = useState<ItensPerUserLogged>()
    const [tabSelecionado, setTabSelecionado] = useState<'Clientes' | 'Consultoria'>("Clientes")
    const [buscar_cliente, setBuscar_cliente] = useState<string>("")
    const [clientes, setClientes] = useState<ClienteItensTypes[]>([])
    const [modulos_clientes, setModulos_clientes] = useState<any[]>([])
    const [modulos, setModulos] = useState<any[]>([])
    const [equipe_cliente, setEquipe_cliente] = useState<EquipeItens[]>([])
    const [equipe_consultoria, setEquipe_consultoria] = useState<EquipeItens[]>([])
    const [perfis, setPerfis] = useState<ItensPerfilTypes[]>([])
    const [perfis_consultoria, setPerfis_consultoria] = useState<ItensPerfilTypes[]>([])
    const [membro_selecionado, setMembro_selecionado] = useState<any>(null)
    const [open_gaveta, setOpen_gaveta] = useState<boolean>(false)
    const [loading_clientes, setLoading_clientes] = useState<boolean>(false)
    const [loading_consultoria, setLoading_consultoria] = useState<boolean>(false)
    const tipoAcesso = secureLocalStorage.getItem('tipo-acesso')
    const codClienteLocal = localStorage.getItem('cod-cliente')
    const isAcessoCliente = tipoAcesso === 'cliente' || (tipoAcesso === 'conta' && !!codClienteLocal && codClienteLocal !== '')
    const dadosClientesLiberados = secureLocalStorage.getItem('Itens') as any[]
    const codContaSelecionada = Number(localStorage.getItem('conta'))
    const contaSelecionada = dadosClientesLiberados?.[0]?.acessoConta?.contas?.find(
        (conta: any) => conta.cod === codContaSelecionada
    )
    const clientesLiberados: { cod: number; nome: string }[] = contaSelecionada?.clientes ?? []

    async function buscarClientes() {
        const response = await getCliente('', '', '', 'modulos', -1)
        const clientesAtivos = response?.data?.itens.filter((item) => item?.status === 1)

        if (clientesLiberados.length > 0) {
            const codClientesLiberados = clientesLiberados.map((c) => c.cod)
            setClientes(clientesAtivos.filter((item) => codClientesLiberados.includes(item?.cod)))
        } else {
            setClientes(clientesAtivos)
        }
    }

    async function buscarPerfils(cod_cliente?: number) {
        const resp = await getPerfil({ embed: 'permissoes', codCliente: cod_cliente })
        setPerfis(limparPermissoesPerfil(resp?.data?.itens))
    }

    async function buscarPerfilsConsultoria() {
        const resp = await getPerfil({ embed: 'permissoes' })
        setPerfis_consultoria(limparPermissoesPerfil(resp?.data?.itens))
    }

    async function buscarEquipe(cod_cliente: number) {
        buscarPerfils(cod_cliente)
        const response = await getEquipe({ codCliente: cod_cliente })

        setEquipe_cliente(response?.data?.itens)
    }

    async function buscarEquipeConsultoria() {
        const response = await getEquipe({ pagination: -1 })
        const vincular_perfis = response?.data?.itens?.filter((item) => item?.status === 1)?.map((item) => {
            const perfil = perfis_consultoria?.find((perfil) => perfil.cod === item?.cod_perfil_conta)

            return {
                ...item,
                perfil
            }
        })
        // Filtra membros que não possuem permissões ativas
        const membros_com_permissoes = vincular_perfis?.filter((item) =>
            item?.perfil?.permissoes && item?.perfil?.permissoes?.length > 0
        )
        setEquipe_consultoria(membros_com_permissoes)
    }

    async function buscarEquipeCliente() {
        setLoading_consultoria(true)
        const codCliente = Number(localStorage.getItem('cod-cliente'))
        const respPerfis = await getPerfil({ embed: 'permissoes', codCliente })
        const perfisCliente = limparPermissoesPerfil(respPerfis?.data?.itens)
        setPerfis(perfisCliente)

        const response = await getEquipe({ codCliente, pagination: -1 })
        const vincular_perfis = response?.data?.itens?.filter((item) => item?.status === 1)?.map((item) => {
            const perfil = perfisCliente?.find((perfil) => perfil.cod === item?.cod_perfil_cliente)

            return {
                ...item,
                perfil
            }
        })
        const membros_com_permissoes = vincular_perfis?.filter((item) =>
            item?.perfil?.permissoes && item?.perfil?.permissoes?.length > 0
        )
        setEquipe_consultoria(membros_com_permissoes)
        setLoading_consultoria(false)
    }

    async function buscarModulos() {
        const response = await tiposSistema(37)
        setModulos(response)
    }


    function abrirGaveta(cod: number) {
        if (tabSelecionado === 'Clientes' && !isAcessoCliente) {
            setLoading_clientes(true)
            buscarEquipe(cod)
            const modulo_cliente = clientes?.find((item) => item?.cod === cod)
            setModulos_clientes(modulo_cliente?.modulos)
            setOpen_gaveta(true)
            setTimeout(() => {
                setLoading_clientes(false)
            }, 1000)
        } else {
            setLoading_consultoria(true)
            const membroEncontrado = equipe_consultoria?.find((item) => item?.cod_func === cod)
            setMembro_selecionado(membroEncontrado || null)
            setOpen_gaveta(true)
            setTimeout(() => {
                setLoading_consultoria(false)
            }, 1000)
        }
    }

    function fecharGaveta() {
        setOpen_gaveta(false)
    }

    useEffect(() => {
        buscarModulos()
        if (isAcessoCliente) {
            buscarEquipeCliente()
        } else {
            buscarClientes()
            buscarPerfilsConsultoria()
        }
    }, [])

    useEffect(() => {
        if (tabSelecionado === 'Consultoria' && !isAcessoCliente) {
            buscarEquipeConsultoria()
        }
    }, [tabSelecionado])
    return (
        <ContainerVisualizarModulosPermissoes>
            <ViewPage
                rotina={25}
                onPermission={setPermissions}
                title='Visualizar modulos e permissões'
                newHide
                hiddeTitle
                cardBodyStyle={{ padding: 15 }}
                cardMainStyle={{ height: '87.5vh', gap: '10px' }}

            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <TitleH1>Visualizar modulos e permissões</TitleH1>
                    <Render condition={!isAcessoCliente}>
                        <Tabs tabs={[{ descricao: "Clientes", icone: "" }, { descricao: "Consultoria", icone: "" }]}
                            selecionado={tabSelecionado} onChange={setTabSelecionado}
                            trackWidth={200}
                            width={410}
                        />
                    </Render>
                </div>
                <ContainerBody>
                    <div>
                        <Input placeholder={isAcessoCliente ? "Buscar membro" : (tabSelecionado === 'Clientes' ? "Buscar cliente" : "Buscar consultor")} value={buscar_cliente} onChange={setBuscar_cliente} />
                    </div>

                    <Render condition={!isAcessoCliente && clientes.length > 0 && tabSelecionado === 'Clientes'}>
                        <CardsDados dados={clientes} buscar_cliente={buscar_cliente} abrir={abrirGaveta} />
                    </Render>
                    <Render condition={!isAcessoCliente && equipe_consultoria.length > 0 && tabSelecionado === 'Consultoria'}>
                        <CardsDadosConsultoria dados_consultoria={equipe_consultoria} buscar_consultoria={buscar_cliente} modulos={modulos} abrir_gaveta={abrirGaveta} />
                    </Render>
                    <Render condition={isAcessoCliente && equipe_consultoria.length > 0}>
                        <CardsDadosConsultoria dados_consultoria={equipe_consultoria} buscar_consultoria={buscar_cliente} modulos={modulos} abrir_gaveta={abrirGaveta} />
                    </Render>
                    <GavetaMostrar
                        membro_selecionado={membro_selecionado}
                        modulos_sistema={modulos}
                        equipe_cliente={equipe_cliente}
                        perfis={perfis}
                        modulos={modulos_clientes}
                        tabSelecionado={isAcessoCliente ? 'Consultoria' : tabSelecionado}
                        aberto={open_gaveta}
                        onClose={fecharGaveta}
                        loading_clientes={loading_clientes}
                        loading_consultoria={loading_consultoria}
                    />
                    <Render condition={!isAcessoCliente && clientes.length === 0 && tabSelecionado === 'Clientes'}>
                        <Carregando animation height={500} legenda="Carregando clientes..." justifyContent="center" size="small" />
                    </Render>
                    <Render condition={!isAcessoCliente && equipe_consultoria.length === 0 && tabSelecionado === 'Consultoria'}>
                        <Carregando animation height={500} legenda="Carregando consultoria..." justifyContent="center" size="small" />
                    </Render>
                    <Render condition={isAcessoCliente && equipe_consultoria.length === 0}>
                        <Carregando animation height={500} legenda="Carregando equipe..." justifyContent="center" size="small" />
                    </Render>

                </ContainerBody>
            </ViewPage>

        </ContainerVisualizarModulosPermissoes>
    );
};

export default VisualizarModulosPermissoes;